import { Injectable } from "@angular/core";
import { RootStoreState } from "@app/root-store";
import { select, Store } from "@ngrx/store";
import { of } from "rxjs";
import { tap } from "rxjs/operators";
import { AddressSelectors } from "..";
import { AddressActions } from "../actions";

@Injectable({
    providedIn: "root",
})
export class AddressService {
    getAddressById$(addressId: number) {
        return addressId
            ? this.store.pipe(
                  select(AddressSelectors.getAddress(addressId)),
                  tap(result => {
                      if (!result) {
                          this.store.dispatch(AddressActions.get({ addressId }));
                      }
                  })
              )
            : of(null);
    }

    constructor(private readonly store: Store<RootStoreState.State>) {}
}
